import Stack from '@mui/material/Stack';

import type { AiModelsCatalogModel } from '@/domain/models/ai-model.js';
import type { ThemeColors } from '@/domain/models/theme.js';
import { ClientIdentitySection } from '@/presentation/pages/clients/components/client-identity-section.js';
import { ClientSlaSection, type ClientSlaFields } from '@/presentation/pages/clients/components/client-sla-section.js';
import { ClientThemeSection } from '@/presentation/pages/clients/components/client-theme-section.js';
import { EmailDomainsSection } from '@/presentation/pages/clients/components/email-domains-section.js';

interface IdentityProps {
    name: string;
    abbreviation: string;
    onNameChange: (value: string) => void;
    onAbbreviationChange: (value: string) => void;
    logoUrl: string | null;
    logoFile: File | null;
    isEdit: boolean;
    onLogoFileSelected: (file: File) => void;
    onRemoveLogoFile: () => void;
    onUploadLogoNow: () => void;
    onRemoveLogo: () => void;
}

interface ThemeProps {
    enabled: boolean;
    colors: ThemeColors;
    onEnabledChange: (enabled: boolean) => void;
    onColorsChange: (colors: ThemeColors) => void;
}

interface Props {
    identity: IdentityProps;
    emailDomains: string[];
    onEmailDomainsChange: (domains: string[]) => void;
    theme: ThemeProps;
    sla: ClientSlaFields;
    onSlaFieldChange: <K extends keyof ClientSlaFields>(key: K, value: ClientSlaFields[K]) => void;
    aiModelsCatalog: AiModelsCatalogModel | null;
    aiModelsLoading: boolean;
    readOnly?: boolean;
}

export function ClientDadosTab({ identity, emailDomains, onEmailDomainsChange, theme, sla, onSlaFieldChange, aiModelsCatalog, aiModelsLoading, readOnly = false }: Props) {
    return (
        <Stack spacing={3}>
            <ClientIdentitySection {...identity} readOnly={readOnly} />
            <EmailDomainsSection domains={emailDomains} onChange={onEmailDomainsChange} readOnly={readOnly} />
            <ClientThemeSection enabled={theme.enabled} colors={theme.colors} onEnabledChange={theme.onEnabledChange} onColorsChange={theme.onColorsChange} readOnly={readOnly} />
            <ClientSlaSection fields={sla} onFieldChange={onSlaFieldChange} aiModelsCatalog={aiModelsCatalog} aiModelsLoading={aiModelsLoading} readOnly={readOnly} />
        </Stack>
    );
}
